var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.8799,
    r: 13.5,
    stroke: "#D4D4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4996 12.1121H14.6661V13.1913C14.9782 12.5706 15.7785 12.013 16.9808 12.013C19.2855 12.013 19.8327 13.2485 19.8327 15.5153V19.7135H17.4993V16.0315C17.4993 14.7406 17.1873 14.0126 16.3928 14.0126C15.2908 14.0126 14.8329 14.7972 14.8329 16.031V19.7135H12.4996V12.1121ZM8.49852 19.6144H10.8318V12.013H8.49852V19.6144ZM11.1661 9.53438C11.1662 9.72995 11.1274 9.9236 11.052 10.1041C10.9766 10.2845 10.8661 10.4482 10.7268 10.5855C10.4447 10.8659 10.0629 11.0228 9.66518 11.0219C9.26816 11.0216 8.8872 10.8651 8.60468 10.5861C8.46597 10.4483 8.35582 10.2844 8.28055 10.104C8.20527 9.92348 8.16635 9.72992 8.16602 9.53438C8.16602 9.13946 8.32352 8.76146 8.60527 8.48263C8.88753 8.2033 9.26866 8.0467 9.66577 8.04688C10.0636 8.04688 10.4451 8.20379 10.7268 8.48263C11.008 8.76146 11.1661 9.13946 11.1661 9.53438Z",
    fill: "#02509A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.1e9304b6cc5385cf35fbc6e4e45d5c9b.svg";
export { ForwardRef as ReactComponent };